import types from './types'

const { TOGGLE_FOOTER } = types

export function toggleFooter() {
  return {
    type: TOGGLE_FOOTER
  }
}
